import React from 'react';
import Dropdown from 'react-bootstrap/Dropdown';
import { Link } from 'react-router-dom';
import './menuNavegacao.css';

interface MenuUsuarioProps {
    logout: () => void;
}

const MenuUsuario: React.FC<MenuUsuarioProps> = ({ logout }) => {
    return (
        <>
            <Dropdown.Item as={Link} to="/milshop/usuario/meus-anuncios" className="custom-dropdown-item">
                Meus Anúncios
            </Dropdown.Item>
            <Dropdown.Item as={Link} to="/milshop/usuario/meus-favoritos" className="custom-dropdown-item">
                Meus Favoritos
            </Dropdown.Item>
            <Dropdown.Divider />
            <Dropdown.Item as="button" onClick={logout} className="custom-dropdown-item">
                Sair
            </Dropdown.Item>
        </>
    );
};

export default MenuUsuario;
